import React, { useImperativeHandle } from 'react';
import { Box } from '@mui/material';
import { IVideoManagementModalProps, VideoManagementModal } from './VideoManagementModal';
import { useVideoManagement } from './useVideoManagement';

interface IVideoManagementDemoProps extends Pick<IVideoManagementModalProps, 'onPreselect'> {
    contestId: string;
}

export interface IVideoManager {
    openModal(): void;
    closeModal(): void;
}

export const VideoManagementDemo = React.forwardRef<IVideoManager, IVideoManagementDemoProps>((props, ref) => {
    const { contestId } = props;
    const {
        submissions,
        loading,
        pagination,
        error,
        selectedVideos,
        filters,
        isModalOpen,
        openModal,
        closeModal,
        handleVideoSelect,
        handleSelectAll,
        handleSendEmail,
        handleFiltersChange,
        handleOfficialSelection,
    } = useVideoManagement(contestId);

    useImperativeHandle(ref, () => ({
        openModal: openModal,
        closeModal: closeModal,
    }));

    return (
        <Box>
            <VideoManagementModal
                open={isModalOpen}
                onClose={closeModal}
                contestId={contestId}
                submissions={submissions}
                pagination={pagination}
                loading={loading}
                error={error}
                selectedVideos={selectedVideos}
                onVideoSelect={handleVideoSelect}
                onSelectAll={handleSelectAll}
                onSendEmail={handleSendEmail}
                onFiltersChange={handleFiltersChange}
                filters={filters}
                onPreselect={handleOfficialSelection}
            />
        </Box>
    );
});
